<div class="row">
    <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="btn btn-sm btn-outline-secondary me-3 mb-2">
            <i class="fa fa-arrow-left" aria-hidden="true" (click)="goBack()">Volver</i>
        </div>
        <h4 class="m-0 text-center flex-grow-1 mb-2">Lista de subsecciones</h4>
        <ng-container *ngIf="accessMP===true">
            <div class="d-flex flex-wrap">
                <div class="d-flex justify-content-end">
                    <a [routerLink]="['../../addAll', idsectionSelected]" class="btn-add">
                        <i class="fa fa-plus px-2"></i> Agregar bloque
                    </a>
                    <a [routerLink]="['../../add', idsectionSelected]" class="btn-add">
                        <i class="fa fa-plus px-2"></i> Agregar nuevo
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail table-success">
                <tr>
                    <th scope="col" class="col-1">N°</th>
                    <th scope="col" class="col-1">Orden</th>
                    <th scope="col" class="col-2">Título</th>
                    <th scope="col" class="col-5">Contenido</th>
                    <th scope="col" class="col-1">Estado</th>
                    <ng-container *ngIf="accessME===true">
                        <th scope="col" class="col-1"></th>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true && !isSectionBlocked">
                        <th scope="col" class="col-1"></th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let o of subsection; let i = index">
                    <td class="col-1">{{ i + 1 }}</td>
                    <td class="col-1">{{ o.order }}</td>
                    <td class="col-2">{{ o.title }}</td>
                    <td class="col-5 text-left">{{ o.content }}</td>
                    <td class="col-1 text-center">
                        <div class="label-active" *ngIf="o.status">ACTIVO</div>
                        <div class="label-inactive" *ngIf="!o.status">INACTIVO</div>
                    </td>
                    <ng-container *ngIf="accessME===true">
                        <td class="col-1 text-center"><a class="a-icon text-center"
                                [routerLink]="['/adm/subseccion/edit', o.id]"><i class="fa fa-pencil i-icon"></i></a>
                        </td>
                    </ng-container>
                    <ng-container *ngIf="accessMD === true && !isSectionBlocked">
                        <td class="col-1 text-center"><a class="a-icon text-center" (click)="remove(o.id, (i+1))"><i
                                    class="fa fa-trash i-icon"></i></a></td>
                    </ng-container>
                </tr>
            </tbody>
        </table>

    </div>
</div>